export type ResolvedTransactionModel = 'legacy' | 'transferGroups';

export type TransactionModel = 'unresolved' | ResolvedTransactionModel;

export type TransactionsIntent =
  | { kind: 'all'; sort?: 'oldestFirst' }
  | { kind: 'byHash'; hashes: string[]; specIdSellId?: string | null }
  | { kind: 'byImports'; credentialIds: number[]; sort?: 'oldestFirst'; specIdSellId?: string | null }
  | { kind: 'byAccounts'; accountIds: number[] }
  | { kind: 'byCurrency'; currency: string; sort?: 'oldestFirst' }
  | { kind: 'byCurrencyOnDate'; date: string; currency?: string }
  | {
      kind: 'byDateCurrencyHash';
      date: string;
      currency?: string | null;
      hash?: string | null;
    }
  | { kind: 'byMethodId'; methodId: string; specIdSellId?: string | null }
  | { kind: 'byContractAddress'; address: string; specIdSellId?: string | null }
  | {
      kind: 'byTransferAddress';
      address: string;
      direction: 'in' | 'out';
      specIdSellId?: string | null;
    }
  | { kind: 'byTransferGroup'; id: string }
  | {
      kind: 'workpaperTransactions';
      credentialIds?: number[] | null;
      reconIdentifier?: string | null;
      contractAddress?: string | null;
      methodId?: string | null;
      manualImportsOnly?: boolean;
      fromDate?: string | null;
      toDate?: string | null;
    }
  | { kind: 'pricingAnomalies' }
  | { kind: 'missingPrices'; fromDate?: string }
  | { kind: 'byReconIdentifier'; reconIdentifier: string; specIdSellId?: string | null }
  | { kind: 'byTxnTopicFingerprint'; fingerprint: string; specIdSellId?: string | null }
  | { kind: 'byTransferTopicFingerprint'; fingerprint: string; specIdSellId?: string | null };

export type LinkResult = { status: 'ok'; href: string } | { status: 'unsupported'; reason: string };

export type IntentAdapter = {
  [K in TransactionsIntent['kind']]: (intent: Extract<TransactionsIntent, { kind: K }>) => LinkResult;
};

export function hrefOf(result: LinkResult | null | undefined): string | undefined {
  return result?.status === 'ok' ? result.href : undefined;
}
